var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    © Copyright "+_vm._s(_vm.year)+" icare 3+1 - All Rights Reserved\n")])}
var staticRenderFns = []

export { render, staticRenderFns }